// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1lzbM","col":"Table_col__3b1Vq","fulfillmentStatus":"Table_fulfillmentStatus__1Z7D8","emailCol":"Table_emailCol__2t9UD"};